import { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import { formatDate } from '../../Components/InputElements';
import axios from "axios";
class Dashboard extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            total_overtime_hrs: 0,
            loadingList: false,
            postLoading: false,
            rows: [],
            employee_info: [],
            modules: [],
            documents: [],
            letters: [],
            salaries: [],
            employee_department: [],
            employee_designation: [],
            employee_location: [],
            employee_grades: [],
        };
    }

    componentDidMount() {
        this.setState({ loadingList: true }, () => {
            this.GetList();
        });
    }



    GetList = () => {
        const { apiURL, apiHeaderJSON, employee_id } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetProfile?employee_id=${employee_id}`, { headers })
            .then((response) => {
                var data = response.data.data;
                if (response.data.success === true) {
                    this.setState({
                        rows: data,
                        employee_info: data.employee,
                        documents: data.documents,
                        letters: data.letters,
                        salaries: data.salary_head,
                        loadingList: false,
                    });
                    var GetMastersEmployeeData = data.employee;
                    this.GetMastersEmployee(GetMastersEmployeeData);
                } else {
                    this.setState({ loadingList: false });
                }
            });
    };


    GetMastersEmployee = (GetMastersEmployeeData) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            department_id: GetMastersEmployeeData.department_id,
            designation_id: GetMastersEmployeeData.designation_id,
            grade_id: GetMastersEmployeeData.grade_id,
            location_id: GetMastersEmployeeData.location_id,
        }
        axios.get(`${apiURL}Home/GetMastersEmployee`, {
            params: formData,
            headers: headers
        }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    employee_department: data.data.department,
                    employee_designation: data.data.designation,
                    employee_location: data.data.location,
                    employee_grades: data.data.grades,
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    };


    render() {
        const { employee_info, employee_department, employee_location, employee_grades } = this.state;
        const locationTitle = employee_location ? employee_location.location_title : 'Loading...';
        return (
            this.state.loadingList === false ?
                (
                    <div class="main-content" >
                        <div class="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`Overview`} primary={`My details`} />
                                <div className="card">
                                    <div className="row">
                                        <div className="col-md-5 d-flex justify-content-center align-items-center" style={{ borderRight: "2px dashed #c7c7c7" }}>
                                            <div style={{ width: "40%" }}>
                                                <img src="assets/profile-pic.png" alt="user-img" className="img-fluid rounded-circle" />
                                            </div>
                                            <div className="profile-info">
                                                {employee_info.employee_name && <h5 className="text-start">{employee_info.employee_name}</h5>}
                                                {employee_info.employee_email_address && <span className="text-muted text-center">{employee_info.employee_email_address}</span>}
                                                <h5 className="text-start mt-3">Date Of Join</h5>
                                                {employee_info.employee_joining_date && <span className="text-muted text-center">{formatDate(employee_info.employee_joining_date)}</span>}
                                                <h5 className="text-start mt-3">Gender</h5>
                                                {employee_info.employee_gender && <span className="text-muted text-center">{employee_info.employee_gender}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <div className="card-body">
                                                <div className="card-header bg-light bg-gradient">
                                                    <h6 className="card-title mb-0 text-start">INFORMATION</h6>
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table table-borderless mb-0">
                                                        <tbody>
                                                            <tr>
                                                                <th className="ps-0" scope="row">Full Name :</th>
                                                                {employee_info.employee_name && <td className="text-muted">{employee_info.employee_name}</td>}
                                                            </tr>
                                                            <tr>
                                                                <th className="ps-0" scope="row">Mobile :</th>
                                                                {employee_info.employee_mobile_number && <td className="text-muted">{employee_info.employee_mobile_number}</td>}
                                                            </tr>
                                                            <tr>
                                                                <th className="ps-0" scope="row">Department :</th>
                                                                {employee_department.department_title && <td className="text-muted">{employee_department.department_title}</td>}
                                                            </tr>
                                                            <tr>
                                                                <th className="ps-0" scope="row">Location :</th>
                                                                {employee_location && employee_location.location_title !== undefined ? (<td className="text-muted">{locationTitle}</td>) : ''}
                                                            </tr>
                                                            <tr>
                                                                <th className="ps-0" scope="row">Grades :</th>
                                                                {employee_grades && employee_grades.grade_title ? (
                                                                    <td className="text-muted">{employee_grades.grade_title}</td>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default Dashboard;